import React from 'react';
import myGlobals from '../Utils/globals';
import { ScaleLoader} from 'react-spinners';
import { myUtilities } from '../Utils';
import { PaymentStatuses, PAYMENT_METHOD_CC, PAYMENt_METHOD_DC } from '../Utils/utils';
import { callReduxConfirmAlertActionWithParameter } from '../App';
import AlertConfirmDialogWithCustomMessage from './Common/AlertConfirmDialogWithCustomMessage';
import { hideConfirmAlertAction } from '../redux/actions/alertConfirmAction';
import { store as reduxStore} from '../redux/store';
class CCProcessor extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            showAlert: false,
            okPressed: false,
            showLoader: true
        };
    }

    onAlertConfirmDialogClick = () => {
        // hide loader
        this.setState({
            okPressed: true,
            showLoader: false
        });
        reduxStore.dispatch(hideConfirmAlertAction());
        // proceed with payment, user has confirmed it

        let cardType = "";
        cardType = myGlobals.jsonString.match("\"cardType\":(\"[a-zA-Z0-9 \n]+\")")[0]
        cardType = cardType.split(":")[1].replaceAll("\"", "");
        console.log(cardType);

        this.proceedWithPayment(true, cardType,false);
    };

    navigateToHomePage = () => {
        console.log("Payment cancelled");
        // hide loader
        this.setState({
            showLoader: false
        });
        if(myGlobals.currentTheme !== 'modernUX.css'){
            this.props.changeSelectedState("SELECTION");
        }
        
        // reset fields
        let discVal = this.props.invData.getTotalDiscountAmount(
            this.props.invData.state.selectedInvoices
        );
        let totalAmt = this.props.invData.getTotalInvoiceAmount(
            this.props.invData.state.selectedInvoices
        );
        if (myGlobals.isDiscountEnabled) {
            totalAmt = parseFloat(totalAmt) - parseFloat(discVal);
        }
        totalAmt = parseFloat(totalAmt).toFixed(2);
        this.props.invData.setState({
            total: totalAmt,
            totalDiscVal: discVal,
        });
        this.props.paymentData.setTotalConvenienceFeeAndSurcharge(null, null);

        // reset late fee
        this.props.paymentData.setTotalLateFee(null);
    }

    render(){
        return (
			<div className="cc-processor-container">
				<div className="centered-container">
					<AlertConfirmDialogWithCustomMessage
						onAlertConfirmDialogClick={() => {
							this.onAlertConfirmDialogClick();
						}}
						customFunction={() => {
							this.navigateToHomePage();
						}}
					/>
					{this.state.showLoader ? (
							<React.Fragment>
								<ScaleLoader
									size={15}
									sizeUnit={"px"}
									color={"#000000"}
									loading={this.state.showLoader}
								/>
								<div className="loading-gif-trifecta" />
								<br />
								{myUtilities.accountSpecificLanguage(
									"Loader.ProcessingPayment",
									"Processing Payment"
								)}
							</React.Fragment>
						) : null
					}
				</div>
			</div>
		);
    }
    ccResponseHandler = (data) => {
        try{
            data = data.rows;
            let status = data.status.toString().toLowerCase();
            if(status.localeCompare('success')===0){
                let message = !myGlobals.isDCFlow
                  ? data.status + "@" +
                    data.ccOnDemandOnAccountId + "@" +
                    data.ccSplitIds + "@" +
                    data.ccPayerId + "@" +
                    data.transactionID
                  : data.status + "@" +
                    data.onDemandOnAccountId + "@" +
                    data.splitIds + "@" +
                    data.payerId + "@" + data.transactionID;;
                window.myFunction(message);
            }
            else if(status.localeCompare('success3ds')===0){
                let message = data.responseConfigs;
                window.cc3dsFunction(message);
            }
            else if(status.localeCompare('faileddc')===0){
                let message = 'Failed';
                window.parentFuncFailureDC(message);
            }
            else if(status.localeCompare('failedccindc')===0) {
                let message = 'Failed';
                window.parentFuncFailureCC(message);
            } else if(status.localeCompare(PaymentStatuses.IN_PROGRESS_STATUS)===0) {
                let message = PaymentStatuses.IN_PROGRESS_STATUS;
                let paymentMethod = myGlobals.isDCFlow
                  ? PAYMENt_METHOD_DC
                  : PAYMENT_METHOD_CC;
                window.inProgressPayment(data);
            }
            else{
                let message = "Payment Status: "+data.status;
                window.failureFunction(message);
            }
        }
        catch(err){
            console.log("Error Ocurred: "+err);
            window.failureFunction(err);
        }
    }
    componentDidMount(){
        // Expose the surcharge popup function to window object for HTML links
        window.openSurchargePopupFromMessage = (surchargeIneligibleInvoicesList) => {
            this.openSurchargePopup(surchargeIneligibleInvoicesList);
        };

        // surcharge based on card brand
        let isOkPressed = this.state.okPressed;
        let totalAmt = this.props.invData.state.total;
        let isSurchargeEnabledOnCardBrand = this.props.invData.state.isSurchargeEnabledOnCardBrand;
        let isSurchargeThroughAPIEnabled = this.props.invData.state.isSurchargeThroughAPIEnabled;
        let isLateFeeEnabled = this.props.invData.state.isLateFeeEnabled;
        let isDiscEnabled = this.props.invData.state.isDiscEnabled;
        let POSMsg ='';
        let TotalAmtMsg= myUtilities.accountSpecificLanguage("TotalAmountMsg","Total Amount");
        let CurrencyMsg= myUtilities.accountSpecificLanguage("CurrencyMsg","Currency");
        let IncludesSurchargeMsg= myUtilities.accountSpecificLanguage("IncludesSurchargeMsg","Includes Surcharge Amount");
        let taxOnSUrchargeMsg= myUtilities.accountSpecificLanguage("TaxOnSurchargeMsg","Tax On Surcharge");
        let breakDownMsg= myUtilities.accountSpecificLanguage("BreakdownMsg","Breakdown");
        let noteMsg= myUtilities.accountSpecificLanguage("NoteMsg","Note");
        let starPaymentSummaryMessage= myUtilities.accountSpecificLanguage("StarPaymentSummaryMessage","*Please see Payment Summary above for details.");
        if (((undefined !== isSurchargeEnabledOnCardBrand && isSurchargeEnabledOnCardBrand) || (undefined !== isSurchargeThroughAPIEnabled && isSurchargeThroughAPIEnabled) ) && !myGlobals.isDCFlow) {
            let cardType = '';
            cardType = myGlobals.jsonString.match("\"cardType\":(\"[a-zA-Z0-9 \n]+\")")[0]
            cardType = cardType.split(":")[1].replaceAll("\"", "");
            console.log(cardType);
            
            let hrToken = '';
            try{
	          if(undefined !== isSurchargeThroughAPIEnabled && isSurchargeThroughAPIEnabled){
	          hrToken = myGlobals.jsonString.match("\"token\":(\"[a-zA-Z0-9 \n]+\")")[0]
              hrToken = hrToken.split(":")[1].replaceAll("\"", "");
              if(cardType != undefined && cardType === 'AmericanExpress'){
                POSMsg = myUtilities.accountSpecificLanguage("Amex.POSMessage","We impose a surcharge* on the transaction amount on American Express card products, which is not greater than our cost of acceptance.");
              }else if(cardType != undefined && cardType != 'AmericanExpress'){
                POSMsg = myUtilities.accountSpecificLanguage("NonAmex.POSMessage_1","We impose a surcharge* on the transaction amount on ")+ cardType + myUtilities.accountSpecificLanguage("NonAmex.POSMessage_2"," credit card products, which is not greater than our cost of acceptance. We do not surcharge ") + cardType + myUtilities.accountSpecificLanguage("NonAmex.POSMessage_3"," debit cards.");
              }
              }
              }catch(e){
	
             }
           

            let isPaymentOnAccount = this.props.invData.state.paymentOnAccount;
            let currency = "";
    
            if (undefined !== isPaymentOnAccount && isPaymentOnAccount.toString().localeCompare('true') === 0) {
                isPaymentOnAccount = true;
            } else {
                isPaymentOnAccount = false;
            }
            
            if (!isPaymentOnAccount) {
                const searchParamsForSurcharge = new URLSearchParams();

                let invoiceNumbers = "";
                this.props.invData.state.selectedInvoices.forEach((invoice) => {
                invoiceNumbers += invoice.accountDocHeaderId + ",";
                });
                invoiceNumbers = invoiceNumbers.substring(0, invoiceNumbers.length - 1);
                let invoiceNumberAndAmount = "&&";
                this.props.invData.state.selectedInvoices.forEach((invoice) => {
                invoiceNumberAndAmount +=
                    invoice.accountDocHeaderId +
                    "@" +
                    invoice.payableAmount2 +
                    '@0@""@""&&';
                });
                invoiceNumberAndAmount = invoiceNumberAndAmount.substring(
                0,
                invoiceNumberAndAmount.length - 2
                );
                searchParamsForSurcharge.append(
                "supplierId",
                window.rsaEncrypt(this.props.invData.state.onDemandAccountId)
                );
                searchParamsForSurcharge.append(
                "customerId",
                window.rsaEncrypt(this.props.invData.state.pkMcarId)
                );
                searchParamsForSurcharge.append(
                "currency",
                window.rsaEncrypt(this.props.invData.state.selectedInvoices[0].currency)
                );

                // global currency
                currency = this.props.invData.state.selectedInvoices[0].currency;
        
                let invoiceNumberAndAmountParam = "";
                let length = invoiceNumberAndAmount.length;
                let invoiceNumberAndAmountBackup = invoiceNumberAndAmount;
                let i = 0;
                while (length > 0) {
                    if (length > 245) {
                        invoiceNumberAndAmountParam =
                        invoiceNumberAndAmountParam +
                        "||" +
                        window.rsaEncrypt(invoiceNumberAndAmountBackup.substring(0, 245));
                        invoiceNumberAndAmountBackup = invoiceNumberAndAmountBackup.substring(
                        245,
                        length
                        );
                        length = length - 245;
                    } else {
                        invoiceNumberAndAmountParam =
                        invoiceNumberAndAmountParam +
                        "||" +
                        window.rsaEncrypt(
                            invoiceNumberAndAmountBackup.substring(0, length)
                        );
                        length = 0;
                    }
                    i = i + 1;
                }
                searchParamsForSurcharge.append("selectedBills", invoiceNumberAndAmountParam);

                let invoiceNumbersParam = "";
                length = invoiceNumbers.length;
                let invoiceNumbersBackup = invoiceNumbers;
                i = 0;
                while (length > 0) {
                    if (length > 245) {
                        invoiceNumbersParam =
                        invoiceNumbersParam +
                        "||" +
                        window.rsaEncrypt(invoiceNumbersBackup.substring(0, 245));
                        invoiceNumbersBackup = invoiceNumbersBackup.substring(245, length);
                        length = length - 245;
                    } else {
                        invoiceNumbersParam =
                        invoiceNumbersParam +
                        "||" +
                        window.rsaEncrypt(invoiceNumbersBackup.substring(0, length));
                        length = 0;
                    }
                    i = i + 1;
                }
                searchParamsForSurcharge.append("selectedArs", invoiceNumbersParam);
                searchParamsForSurcharge.append("sourceApp", window.rsaEncrypt("Guest"));
                searchParamsForSurcharge.append("cardType", window.rsaEncrypt(cardType));
                searchParamsForSurcharge.append("isSurchargeEnabledOnCardBrand", window.rsaEncrypt(isSurchargeEnabledOnCardBrand));
                searchParamsForSurcharge.append("isSurchargeThroughAPIEnabled", window.rsaEncrypt(isSurchargeThroughAPIEnabled));
                searchParamsForSurcharge.append("hrTokenNumber", window.rsaEncrypt(hrToken));
                searchParamsForSurcharge.append("configJson", myGlobals.jsonString);

                let link = "checkCreditCardForSupplierWithoutLogin";
                link = myGlobals.initialHost+myGlobals.appender + link;
                fetch(link, {
                    method: "POST",
                    body: searchParamsForSurcharge
                }).then(
                    function(response) {
                        if (response.status !== 200) {
                            console.log('Looks like there was a problem. Status Code: ' +
                            response.status);
                            throw new Error("Status Code: "+response.status);
                        }
                        return response.json();
                    }
                ).then(
                    // Show pop-up to user, proceed ONLY if user clicks on yes
                    (data) => {
                        let messageString="";
                        let surchargeResponse = "";
                        let showPOSMessage="";
                        let surchargePercentShow = "";
                        let isSameSurchargePercentage = false;
                        let showDataInGrid = false;
                        let totalAmount = parseFloat(totalAmt);
                        let totalSurchargeAmount = undefined != data.rows[0].totalSurchargeAmount ? data.rows[0].totalSurchargeAmount : 0;
                        let totalTaxOnSurchargeAmount = undefined != data.rows[0].totalTaxOnSurcharge ? data.rows[0].totalTaxOnSurcharge : 0.00;
                        let surchargeIneligibleInvoicesList = undefined != data.rows[0].surchargeInEligibleInvoicesList ? data.rows[0].surchargeInEligibleInvoicesList : "";
                        
                        // Get surcharge info icon HTML string for inline display
                        let surchargeInfoIcon = this.getSurchargeInfoIcon(surchargeIneligibleInvoicesList);
                        
                        totalAmount = parseFloat(totalAmount) + parseFloat(totalSurchargeAmount);
						totalAmount = parseFloat(totalAmount).toFixed(2);
                        totalSurchargeAmount = parseFloat(totalSurchargeAmount).toFixed(2);
                        totalTaxOnSurchargeAmount = parseFloat(totalTaxOnSurchargeAmount).toFixed(2);
                        messageString = TotalAmtMsg+" : " + totalAmount + "\n"+CurrencyMsg+" : " + currency +"\n"+IncludesSurchargeMsg+" : " + totalSurchargeAmount + surchargeInfoIcon;
                        if(data.rows[0]?.surchargeSummaryDTOs != undefined  && data.rows[0]?.surchargeSummaryDTOs.length > 0){
                            surchargeResponse = data.rows[0].surchargeSummaryDTOs;
                            let firstSurchargePercentage = surchargeResponse[0].surchargePercentage;
                            isSameSurchargePercentage = surchargeResponse.every(item => item.surchargePercentage === firstSurchargePercentage);
                            let isAllSurchargePercentageZero = surchargeResponse.every(item => item.surchargePercentage === 0);
                            if(surchargeResponse.length == 1 || isSameSurchargePercentage || isAllSurchargePercentageZero){
                                totalAmount = parseFloat(totalAmt) + parseFloat(surchargeResponse[0].surchargeAmount);
                                totalSurchargeAmount = parseFloat(surchargeResponse[0].surchargeAmount);
                                totalAmount = parseFloat(totalAmount).toFixed(2);
                                if(totalSurchargeAmount > 0 && surchargeResponse[0]?.surchargePercentage !=undefined){
                                    showPOSMessage = "<b>"+noteMsg+": "+"</b>"+POSMsg + "\n" +"<i>"+starPaymentSummaryMessage+"</i>";
                                    surchargePercentShow = `(${surchargeResponse[0]?.surchargePercentage}%)`;
                                    messageString = TotalAmtMsg+" : " + totalAmount + "\n"+CurrencyMsg+" : " + currency +"\n"+IncludesSurchargeMsg+" : " + totalSurchargeAmount+ surchargePercentShow + surchargeInfoIcon +"\n\n"+showPOSMessage;
                                    if(totalTaxOnSurchargeAmount > 0.00){
                                    messageString = TotalAmtMsg+" : " + totalAmount + "\n"+CurrencyMsg+" : " + currency +"\n"+IncludesSurchargeMsg+" : " + totalSurchargeAmount+ surchargePercentShow + surchargeInfoIcon +"\n"+taxOnSUrchargeMsg+" : "+totalTaxOnSurchargeAmount+"\n\n"+showPOSMessage;
                                    }
                                }
                            }else{
                                showDataInGrid = true;
                                showPOSMessage = "<b>"+noteMsg+": "+"</b>"+POSMsg + "\n" +"<i>"+starPaymentSummaryMessage+"</i>";
                                if(totalTaxOnSurchargeAmount  > 0.00){
                                    messageString += "\n"+taxOnSUrchargeMsg+" : "+totalTaxOnSurchargeAmount;
                                    }
                                messageString += "\n\n"+showPOSMessage;
                            }
                        }
                        // we have got successful response from backend, show the popup to the user
                        if (!isOkPressed) {
							callReduxConfirmAlertActionWithParameter(
								"Alert.ViewPaymentSummary",
								"View Payment Summary",
								"Alert.PaymentConfirmation",
								messageString,
								{
									totalAmount: totalAmount,
									currency: currency,
									totalSurchargeAmount: totalSurchargeAmount,
                                    surchargeResponse: surchargeResponse,
                                    showGrid: showDataInGrid,
                                    totalTaxOnSurchargeAmount:totalTaxOnSurchargeAmount,
                                    isLateFeeEnabled: isLateFeeEnabled,
                                    isDiscEnabled: isDiscEnabled,
                                    showPOSMessage: showPOSMessage,
                                    surchargePercentShow: surchargePercentShow
								},
								"AlertDialog.ProceedToPay",
								"Proceed to Pay"
							);
						}
                    }
                ).catch(
                    function (err) {
                        console.log('Fetch Error :-S', err);
                        window.failureFunction(err);
                    }
                );
            } else {
                // POA
                const searchParamsForSurchargePOA = new URLSearchParams();
                searchParamsForSurchargePOA.append(
                "supplierId",
                window.rsaEncrypt(this.props.invData.state.onDemandAccountId)
                );
                searchParamsForSurchargePOA.append(
                "customerMapId",
                window.rsaEncrypt(this.props.invData.state.pkMcarId)
                );
                searchParamsForSurchargePOA.append(
                "currency",
                window.rsaEncrypt(this.props.invData.state.currency)
                );
                searchParamsForSurchargePOA.append(
                "paymentAmount",
                window.rsaEncrypt(this.props.invData.state.payableAmount)
                );
                searchParamsForSurchargePOA.append("isSupplier", window.rsaEncrypt(true));
                searchParamsForSurchargePOA.append("cardType", window.rsaEncrypt(cardType));
                searchParamsForSurchargePOA.append("isSurchargeEnabledOnCardBrand", window.rsaEncrypt(isSurchargeEnabledOnCardBrand));
                searchParamsForSurchargePOA.append("isSurchargeThroughAPIEnabled", window.rsaEncrypt(isSurchargeThroughAPIEnabled));
                searchParamsForSurchargePOA.append("hrTokenNumber", window.rsaEncrypt(hrToken));

                // global currency
                currency = this.props.invData.state.currency;

                let link = "getConvenienceFeeForPaymentOnAccountWithoutLogin";
                link = myGlobals.initialHost+myGlobals.appender + link;
                fetch(link, {
                    method: "POST",
                    body: searchParamsForSurchargePOA
                }).then(
                    function(response) {
                        if (response.status !== 200) {
                            console.log('Looks like there was a problem. Status Code: ' +
                            response.status);
                            throw new Error("Status Code: "+response.status);
                        }
                        return response.json();
                    }
                ).then(
                    // Show pop-up to user, proceed ONLY if user clicks on yes
                    (data) => {
                        let showPOSMessage="";
                        let surchargePercentShow = "";
                        let totalAmount = parseFloat(totalAmt);
                        let totalSurchargeAmount = undefined != data.rows[0].totalSurchargeAmount ? data.rows[0].totalSurchargeAmount : 0;
                        let totalSurchargePercentage = undefined != data.rows[0].totalSurchargePercentage ? data.rows[0].totalSurchargePercentage : 0;
                        let totalTaxOnSurchargeAmount = undefined != data.rows[0].totalTaxOnSurcharge ? data.rows[0].totalTaxOnSurcharge : 0;
                        let surchargeIneligibleInvoicesList = undefined != data.rows[0].surchargeInEligibleInvoicesList ? data.rows[0].surchargeInEligibleInvoicesList : "";
                        
                        // Get surcharge info icon HTML string for inline display
                        let surchargeInfoIcon = this.getSurchargeInfoIcon(surchargeIneligibleInvoicesList);
                        
                        totalAmount = parseFloat(totalAmount) + parseFloat(totalSurchargeAmount);
						totalAmount = parseFloat(totalAmount).toFixed(2);
                        totalSurchargeAmount = parseFloat(totalSurchargeAmount).toFixed(2);
                        totalTaxOnSurchargeAmount = parseFloat(totalTaxOnSurchargeAmount).toFixed(2);
                        let messageString = TotalAmtMsg+" : " + totalAmount + "\n"+CurrencyMsg+" : " + currency +"\n\n"+breakDownMsg+" :\n"+IncludesSurchargeMsg+" : " + totalSurchargeAmount + surchargeInfoIcon;
                        if(totalSurchargePercentage > 0){
                            surchargePercentShow = `(${totalSurchargePercentage}%)`;
                            showPOSMessage = "<b>"+noteMsg+": "+"</b>"+POSMsg+ "\n" +"<i>"+starPaymentSummaryMessage+"</i>";
                            messageString = TotalAmtMsg+" : " + totalAmount + "\n"+CurrencyMsg+" : " + currency +"\n\n"+breakDownMsg+" :\n"+IncludesSurchargeMsg+" : " + totalSurchargeAmount + surchargePercentShow + surchargeInfoIcon +"\n\n"+showPOSMessage;
                        }
                        if(totalTaxOnSurchargeAmount > 0.00 && totalSurchargePercentage > 0){
                            messageString = TotalAmtMsg+" : " + totalAmount + "\n"+CurrencyMsg+" : " + currency +"\n\n"+breakDownMsg+" :\n"+IncludesSurchargeMsg+" : " + totalSurchargeAmount + surchargePercentShow + surchargeInfoIcon +"\n"+taxOnSUrchargeMsg+" : "+totalTaxOnSurchargeAmount+"\n\n"+showPOSMessage;
                        }else if (totalTaxOnSurchargeAmount > 0.00){
                            messageString = TotalAmtMsg+" : " + totalAmount + "\n"+CurrencyMsg+" : " + currency +"\n\n"+breakDownMsg+" :\n"+IncludesSurchargeMsg+" : " + totalSurchargeAmount + surchargeInfoIcon +"\n"+taxOnSUrchargeMsg+" : "+totalTaxOnSurchargeAmount;
                        }

                        // we have got successful response from backend, show the popup to the user   
                        if (!isOkPressed) {
                            callReduxConfirmAlertActionWithParameter(
                                "Alert.ViewPaymentSummary",
								"View Payment Summary",
                                "Alert.PaymentConfirmation",
                                messageString,
                                {
                                    totalAmount: totalAmount,
                                    currency: currency,
                                    totalSurchargeAmount: totalSurchargeAmount,
                                    totalTaxOnSurchargeAmount:totalTaxOnSurchargeAmount,
                                    showPOSMessage: showPOSMessage,
                                    surchargePercentShow: surchargePercentShow
                                },
                                "AlertDialog.ProceedToPay",
                                "Proceed to Pay"
                            );
                        }
                    }
                ).catch(
                    function (err) {
                        console.log('Fetch Error :-S', err);
                        window.failureFunction(err);
                    }
                );
            }
        } else {
            // surcharge based on card brand is disabled, normal flow
            this.proceedWithPayment(false, null,false);
        }

    }

    proceedWithPayment(isSurchargeEnabledOnCardBrand, cardType,isSurchargeThroughAPIEnabled) {
        const searchParams = new URLSearchParams();
        searchParams.append('jsonString', myGlobals.jsonString);
        searchParams.append('isSurchargeEnabledOnCardBrand', isSurchargeEnabledOnCardBrand);
        searchParams.append('isSurchargeThroughAPIEnabled', isSurchargeThroughAPIEnabled);
        if (null != cardType) {
            searchParams.append('cardType', cardType);
        }
        let link = !myGlobals.isDCFlow ?
            "ccPaymentProcessingAction" : "dcPaymentProcessingAction";
        link = myGlobals.initialHost + myGlobals.appender + link;
        fetch(link, {
            //https://api.jsonbin.io/b/5ed0b9b37741ef56a563eafc
            method: "POST",
            body: searchParams
        }).then(
            function (response) {
                if (response.status !== 200) {
                    console.log('Looks like there was a problem. Status Code: ' +
                        response.status);
                    throw new Error("Status Code: " + response.status);
                }
                return response.json();
            }
        ).then((data) => {
            this.ccResponseHandler(data);
        }).catch(
            function (err) {
                console.log('Fetch Error :-S', err);
                window.failureFunction(err);
            }
        );
    }

    // Opens popup with surcharge ineligible invoices list
    openSurchargePopup = (surchargeInEligibleInvoices1) => {
        try {
            if (!surchargeInEligibleInvoices1) return;
            
            // Parse the data - could be string or array
            let invoicesArray = Array.isArray(surchargeInEligibleInvoices1) 
                ? surchargeInEligibleInvoices1 
                : surchargeInEligibleInvoices1.split(',').map(invoice => invoice.trim()).filter(invoice => invoice !== '');
            
            if (invoicesArray.length === 0) return;
            
            const title = myUtilities.accountSpecificLanguage('EIPP_SURCHARGE_NOT_ELIGIBLE_INVOICES','Surcharge Not Eligible Invoices');
            const invoiceList = invoicesArray.join(', ');
            const message = `${title}:\n\n${invoiceList}`;
            
            // Using alert for now - can be replaced with React modal later
            alert(message);
            
        } catch (error) {
            console.error('Error in openSurchargePopup:', error);
            // Show fallback message
            alert('Unable to display surcharge invoice details. Please contact support.');
        }
    };

    // Gets surcharge info icon HTML string for inline display in message
    getSurchargeInfoIcon = (surchargeIneligibleInvoicesList) => {
        if (!surchargeIneligibleInvoicesList || surchargeIneligibleInvoicesList.trim() === '') {
            return '';
        }

        const invoicesArray = surchargeIneligibleInvoicesList.split(',').map(invoice => invoice.trim()).filter(invoice => invoice !== '');
        
        if (invoicesArray.length === 0) {
            return '';
        }

        if (invoicesArray.length <= 3) {
            // Simple tooltip for ≤3 invoices - only hover, no click
            const tooltipContent = myUtilities.accountSpecificLanguage('EIPP_INVOICE_NUMBERS','Invoice Number(s) ') + 
                                 invoicesArray.join(', ') + 
                                 myUtilities.accountSpecificLanguage('EIPP_SURCHARGE_EXEMPT',' are exempt from Surcharge.');

            return ` <img src="./Images/info.png" alt="Info" title="${tooltipContent.replace(/"/g, '&quot;')}" style="width: 16px; height: 16px; margin-left: 3px; vertical-align: middle;" />`;
        } else {
            // Clickable icon for >3 invoices with default browser tooltip
            const tooltipContent = myUtilities.accountSpecificLanguage('EIPP_SURCHARGE_EXEMPT_MORE','Some of the invoices are exempt from Surcharge. ') + 
                                  myUtilities.accountSpecificLanguage('EIPP_MORE_DETAILS','Click to see details.');

            return ` <img src="./Images/info.png" alt="Info" 
                          title="${tooltipContent.replace(/"/g, '&quot;')}"
                          onclick="window.openSurchargePopupFromMessage('${surchargeIneligibleInvoicesList.replace(/'/g, "\\'")}'); return false;" 
                          style="width: 16px; height: 16px; margin-left: 3px; vertical-align: middle; cursor: pointer;" />`;
        }
    };

    componentWillUnmount() {
        // Clean up the global window function
        try {
            if (window.openSurchargePopupFromMessage) {
                delete window.openSurchargePopupFromMessage;
            }
        } catch (error) {
            console.error('Error cleaning up window function:', error);
        }
    }
}

export default CCProcessor;